<template>
    <div class="px-4 py-2">
        <h2>Nível do Reservatório</h2>
        <b-row align-h="center">
            <b-col xl="9" cols="12">
                <b-card
                    header="Dados de cota"
                    header-bg-variant="secondary"
                    header-text-variant="white"
                    class="shadow-sm"
                >
                    <b-row class="justify-content-center">
                        <b-col xl="8" cols="12">
                            <date-range-selector
                                ref="dateSelector"
                                label="Intervalo de tempo"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="text-center">
                            <b-overlay
                                :show="loadingChart"
                                class="d-inline-block"
                                variant="white"
                                :rounded="true"
                                spinner-small
                            >
                                <b-button
                                    class="pl-1"
                                    :disabled="loadingChart"
                                    @click="onUpdateChart"
                                >
                                    <i class="fas fa-sm fa-sync-alt mx-1" />
                                    Atualizar gráfico
                                </b-button>
                            </b-overlay>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row align-h="center" class="mt-3">
            <b-col xl="9" cols="12">
                <reservoir-chart
                    ref="chart"
                    :loading="loadingChart"
                    :include-water-gates="includeWaterGates"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ReservoirChart from "./components/ReservoirChart";
import DateRangeSelector from "@/components/DateRangeSelector";
import sleep from "@/utils/sleep";

export default {
    name: "ViewReservoir",
    components: {
        DateRangeSelector,
        ReservoirChart
    },
    props: {
        getReservoirInfos: {
            type: Function,
            default() {
                return () => {};
            }
        },
        includeWaterGates: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loadingChart: false
        };
    },
    methods: {
        async onUpdateChart() {
            this.loadingChart = true;

            const { startDate, endDate } = this.$refs.dateSelector.value;

            try {
                const { data } = await this.getReservoirInfos(
                    startDate,
                    endDate
                );
                await this.$refs.chart.update(data);
            } catch (error) {
                if (error.response) {
                    console.log(error.response.data);
                }
                this.$bvToast.toast(
                    `Erro ao efetuar a busca de dados reservatório, tente novamente mais tarde.`
                );

                throw error;
            }

            await sleep(1000);

            this.loadingChart = false;
        }
    }
};
</script>
